import React from 'react'
import { Dumbbell, Footprints, Target, Sparkles } from 'lucide-react'
import { cn } from '../../../lib/utils'

// Per-muscle-group default visual for exercises without a real photo.
// Combines a colored gradient background with a Lucide icon so every
// seeded or photo-less custom exercise still feels distinct on the card
// grid, detail hero, and picker row.
const STYLES = {
  chest:      { gradient: 'from-app-primary-400 to-red-500',                Icon: Dumbbell },
  back:       { gradient: 'from-blue-400 to-indigo-500',               Icon: Dumbbell },
  shoulders:  { gradient: 'from-violet-400 to-purple-500',             Icon: Dumbbell },
  biceps:     { gradient: 'from-amber-400 to-app-primary-500',              Icon: Dumbbell },
  triceps:    { gradient: 'from-yellow-400 to-amber-500',              Icon: Dumbbell },
  quads:      { gradient: 'from-emerald-400 to-green-500',             Icon: Footprints },
  hamstrings: { gradient: 'from-teal-400 to-emerald-500',              Icon: Footprints },
  glutes:     { gradient: 'from-pink-400 to-rose-500',                 Icon: Footprints },
  core:       { gradient: 'from-yellow-300 to-amber-400',              Icon: Target },
  full_body:  { gradient: 'from-app-primary-500 via-red-400 to-purple-500', Icon: Sparkles },
}

const DEFAULT = STYLES.full_body

export default function ExercisePlaceholder({ muscleGroup, iconClassName, className }) {
  const style = STYLES[muscleGroup] || DEFAULT
  const Icon = style.Icon
  return (
    <div
      aria-hidden="true"
      className={cn(
        'w-full h-full flex items-center justify-center bg-gradient-to-br',
        style.gradient,
        className
      )}
    >
      <Icon className={cn('text-white/85 drop-shadow-sm', iconClassName || 'w-10 h-10')} />
    </div>
  )
}
